module.exports = __webpack_public_path__ + "static/media/ic_error_danger.95be0e97.svg";